export default __webpack_public_path__ + "static/media/img3.b0835ad4.jpg";